export const SLIDER_WIDTH = 202;
export const SLIDER_DOT_WIDTH = 20;
export const SLIDER_MAX_VALUE = SLIDER_WIDTH - SLIDER_DOT_WIDTH;
export const SLIDER_CONTAINER_HEIGHT = SLIDER_DOT_WIDTH + 16;

export const SLIDER_CROP_WIDTH = 69;
export const SLIDER_DOT_CROP_WIDTH = 14;
export const SLIDER_CROP_MAX_VALUE = SLIDER_CROP_WIDTH - SLIDER_DOT_CROP_WIDTH;
export const SLIDER_CONTAINER_CROP_HEIGHT = SLIDER_DOT_CROP_WIDTH + 16;
